export const MobileRecordingIcon = (): JSX.Element => (
   <svg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='19' cy='19' r='19' fill='#C86262' />
      <circle cx='19' cy='19' r='15' fill='#FFFFFF' />
      <circle cx='19' cy='19' r='7' fill='#C86262' />
   </svg>
);
